import { render } from "./Livros.vue?vue&type=template&id=4542fabc&scoped=true"
import script from "./Livros.vue?vue&type=script&lang=js"
export * from "./Livros.vue?vue&type=script&lang=js"

import "./Livros.vue?vue&type=style&index=0&id=4542fabc&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4542fabc"]])

export default __exports__